import clsx from "clsx";
import Link from "next/link";

import HeadingTag from "@components/HeadingTag";
import Target from "@components/Target";
import { getHref } from "@lib/routes";
import DotBorder from "./DotBorder";

const PageTitle = ({
	children,
	target = null,
	breadcrumb = null,
	headingTag = "h1",
	summary = null,
}) => {
	return (
        <div className={clsx("PageTitle--container py-15")}>
			<div
				className={clsx(
					"PageTitle--content bg-white-01  max-w-screen-xl mx-auto px-5 py-15 relative box-sizing"
				)}
			>
				{!!breadcrumb && (
					<div
						className={clsx(
							"PageTitle__breadcrumb",
							"text-sm opacity-25",
							"px-5 mb-4",
							"max-w-screen-xl mx-auto"
						)}
					>
						<Link href={getHref(breadcrumb)}>
							{breadcrumb.title}
						</Link>
					</div>
				)}

				<HeadingTag
					tag={headingTag}
					className={clsx(
						"PageTitle__heading",
						"text-3xl lg:text-5xl font-medium",
						"px-3 md:px-7.5 lg:px-5",
						{
							"mb-7.5": !summary,
							"mb-3": summary,
						},
						"max-w-screen-xl mx-auto"
					)}
				>
					<Target target={target} className={clsx("PageTitle__link")}>
						{children}
					</Target>
				</HeadingTag>

				{summary && (
					<div
						className={clsx(
							"PageTitle__summary",
							"px-3 md:px-7.5 lg:px-5",
							"max-w-screen-xl mx-auto text-purple-01"
						)}
					>
						<div className={clsx("PageTitle__summary-text text-2xl max-w-3xl")}>
							{summary}
						</div>
					</div>
				)}
				<DotBorder />
			</div>
		</div>
    );
};

export default PageTitle;
